import { CustomWindow } from '@utils/models/customwindow';
import { useGeneral } from '@utils/general';
import { useVideoBlockYouTube } from './video-youtube';

declare let window: CustomWindow;

export const useBlockMedia = () => {
  const { loadImage } = useGeneral();
  const initialize = () => {
    setVideoHeight();
    
    window.addEventListener("resize", () => setVideoHeight(true));
    
    if (!!document.querySelector(".video__content--youtube")) {
      useVideoBlockYouTube();
    }

    // Iframe has loaded
    window.iframeLoadedHandler = (iframeElement: HTMLIFrameElement) => {
      const element = iframeElement.closest(".video__content") as HTMLElement;
      element.classList.add("video__content--show-video");
      element.classList.remove("video__content--load-video");
    };

    document.addEventListener('DOMContentLoaded', () => {
        const links = document.querySelectorAll('.cookiebot-banner');
        links.forEach(link => {
          link.addEventListener('click', event => {
            event.preventDefault();
            window.Cookiebot.renew();
          });
        });
      });

    window.KnowitOptimizelyFramework.BlockMediaScriptIsInitialized = true;
  }
  
  const initializeConsentCheck = (elements: NodeListOf<HTMLElement>) => {
    // If marketing cookies are blocked by CookieBot
    if (!window.Cookiebot?.consent?.marketing) {

      // Initialize YouTube
      elements.forEach(element => {
        let blockElement = element as HTMLElement;

        // If this script is already initialized
        if (blockElement.dataset.initializedConsent === "true") {
          return;
        }

        blockElement.classList.add("video__content--prevent-video");

        blockElement.addEventListener("click", () => {
          blockElement.classList.add("video__content--show-video")
        });

        blockElement.addEventListener("keypress", (e: any) => {
          if (e.key === 'Enter') {
            blockElement.classList.add("video__content--show-video")
          }
        });

        // Set initialized attribute to prevent this script from running again
        blockElement.dataset.initializedConsent = "true";
      });
    }
  }

  const setVideoHeight = (isResize: boolean | null = false) => {
    document.querySelectorAll(".video__content").forEach(element => {
      let block = element as HTMLElement;
      let blockMediaIcon = block.querySelector(".video__icon") as HTMLDivElement;

      if ((block.dataset.initializedSetHeight === "true" && !isResize) || !blockMediaIcon) {
        return;
      }

      const image = block.querySelector("img") as HTMLImageElement;

      if (!!image) {
        loadImage(image).then((loadedImage: HTMLImageElement) => {
          // Use timeout to let the layout transition finish first
          setTimeout(() => {
            if (block instanceof HTMLElement) {
              let imgHeight = loadedImage.offsetHeight;

              // Set video height, this will position the icon in the middle
              let blockVideo = block.querySelector(".video__media");
              if (blockVideo instanceof HTMLElement && !!imgHeight) {
                blockVideo.style.height = `${imgHeight}px`;
              }
            }
          }, 100);
        }); 
      }

      block.dataset.initializedSetHeight = "true";
    });
  }

  return {
    initialize,
    initializeConsentCheck
  }
}

// Stage 1: Cookiebot is loaded
window.CookiebotCallback_OnLoad = () => {
  if (!window.KnowitOptimizelyFramework.BlockMediaScriptIsInitialized) {
    useBlockMedia().initialize();
  }
};

// Add ready class to video blocks when Cookiebot is loaded
window.addEventListener('CookiebotOnLoad', function (e) {
  document.querySelectorAll(".video__content").forEach(videoBlockContentElement => {
    videoBlockContentElement.classList.add("video__content--ready");
  });
});